/**
 * camelCase field key (as used in the order views and the PRO card columns) → legacy
 * DB column name.
 *
 * Only the MISMATCHES need an entry — for everything else `key.toLowerCase()` already
 * equals the DB column, because the legacy columns are all-lowercase with no
 * separators (portOfOrigin→portoforigin, revisedEtaDatetime→revisedetadatetime).
 *
 * Lives in its own leaf module because two very different consumers need it: the
 * order form's display-rule hook, and the Search Results edit gate — which is a pure
 * module and must not pull the API client (and with it MSAL and `window`) into its
 * import graph just to resolve a column name.
 */
export const ORDER_FIELD_DB_NAMES: Record<string, string> = {
  firstRcv: 'firstrcvdate',
  lastFreeDay: 'lastfreedaydate',
  examLfd: 'examlfddate',
  availToShipDatetime: 'availabletoshipdatetime',
  availToShipUser: 'availabletoshipuser',
  traceMode: 'mode',           // Tracing "Mode" key is traceMode; DB column is `mode`
  addlInfoDeleted: 'deleted',  // Addl Info delete flag; DB column is `deleted`
  custDocCut: 'dvirlights',    // Customer Document Cutoff — repurposed dvirlights column
  bobtailApproved: 'bobtail_approved', // the one underscored order column (added 2026-09-08)
};

/** The legacy DB column for a field key: the mismatch map, else plain lowercase. */
export function toDbName(key: string): string {
  return ORDER_FIELD_DB_NAMES[key] ?? key.trim().toLowerCase();
}
